<div
    class="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16">
    <div class="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
        <div class="relative">
            <div class="absolute">
                <div class="">
                    <h1 class="my-2 text-gray-800 font-bold text-2xl">
                        {{ errorMessage }}
                    </h1>
                    <p class="my-2 text-gray-800">Desculpe por isso! Por favor tente novamente.</p>
                </div>
            </div>
            <div>
                <h1 class="text-9xl text-gray-100 font-extrabold">{{ errorCode }}</h1>
            </div>
        </div>
    </div>
    <div>
        <img src="assets/socket.png" />
    </div>
</div>